import apiClient from '../apiClient';
import { GET_USER_PROFILE_BY_USER_ID } from '../apiUrl';

const getUserProfileByUserIdApi = Id => {
  return apiClient.get(GET_USER_PROFILE_BY_USER_ID(Id));
};

export default getUserProfileByUserIdApi;
